// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"118": "lib-router","72": "lib-axios",}[chunkId] || chunkId) + "." + {"118": "04a47720","366": "c7d8f862","445": "5ac9445e","646": "c108c810","659": "c63489b8","72": "008fbfbb",}[chunkId] + ".js"
}